import { PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent } from 'react';
import Button from '../../Button';
import Link from 'next/link';
import ClaimProfileWrapper from '../Wrapper';
import styles from './styles.module.scss';
import ArrowRightIcon from '../../Icons/ArrowRightIcon';
import EnvelopeSolidIcon from '../../Icons/EnvelopeSolidIcon';
import EllipsisIcon from '../../Icons/EllipsisIcon';

export type ClaimProfileByEmailProps = {
    educator: PublicEducator;
    onVerifyAnotherWayClick: () => void;
    onSendVerificationClick: () => void;
};

export const ClaimProfileByEmailPage: FunctionComponent<ClaimProfileByEmailProps> = ({
    educator,
    onSendVerificationClick,
    onVerifyAnotherWayClick,
}) => {
    return (
        <ClaimProfileWrapper educator={educator}>
            <div className={styles.container}>
                <h3 className={styles.header}>Verify your ownership</h3>
                <p className={styles.description}>
                    To verify this profile, we will send a verification code to this address:
                </p>
                <p className={styles.email}>{educator.redacted_email}</p>
                <Button preset="primary" onClick={onSendVerificationClick}>
                    <EnvelopeSolidIcon /> Send Verification Code
                </Button>
                <Button preset="default" onClick={onVerifyAnotherWayClick}>
                    <EllipsisIcon /> Verify Another Way
                </Button>
                <Link
                    className={styles.hasCodeLink}
                    href={`${process.env.NEXT_PUBLIC_ADMIN_URL}/claim-profile?educator_param=${encodeURIComponent(educator.slug)}`}
                >
                    Enter Verification Code <ArrowRightIcon />
                </Link>
            </div>
        </ClaimProfileWrapper>
    );
};

export default ClaimProfileByEmailPage;
